// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"37":"postload","160":"components","173":"beyond-identity-wrapper","330":"priority","351":"commons","892":"subscription-modals","953":"beyond-identity-sdk"}[chunkId] || chunkId) + ".chunk.B16CoriginmasterD20260826191026.js";
};